import React, { useEffect, useState } from "react";
import { UserEnquiryService } from "../../Services/EnquiryServices";
import { MdVisibility } from "react-icons/md";
import { useHistory } from "react-router";
import { Button, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
let currentPage1 = 1;

export const EnquiryList = () => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [enquirylist, setEnquirylist] = useState([]);
  const [searchField, setSearchField] = useState();
  const [quotationstatus, setQuotationstatus] = useState("");
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  const handleSelect = (e) => {
    setQuotationstatus(e.target.value);
  };

  const getData = async () => {
    setLoader(true);
    let param = { page : currentPage, limit : pagination.limit };
    if(quotationstatus !== "all"){
       param = {...param, quotation: quotationstatus};
    }
    if (searchField) {
      param["search"] = searchField;
    }
    await UserEnquiryService.getEnquiry(param)
      .then((res) => {
        setEnquirylist(res.data);
        setLoader(false);
        setPagination({ ...pagination, ...res.pagination });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // updateEnquiryState

  const handleCotation = async (item) => {
    let param = {
      id: item?._id,
    };

    // if(quotationstatus !== "all"){
      if (item?.quotation_send === true) {
        param = { ...param, quotation_send: false };
      } else {
        param = { ...param, quotation_send: true };
      }
    // }


    await UserEnquiryService.updateEnquiryState(param)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getData();
  }, [searchField, quotationstatus, currentPage]);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25"></div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-sm-3 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>
              <div className="col-sm-3 mb-3">
                <select
                  onChange={(e) => handleSelect(e)}
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option selected value="all">ALL</option>
                  <option value="true">Quoted</option>
                  <option value="false">Not Quoted</option>
                </select>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Enquiry no.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Contact No.</th>
                    <th>Date</th>
                    <th>Address</th>
                    <th>Quotation Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {enquirylist &&
                    enquirylist.length > 0 &&
                    enquirylist.map((item, key) => {
                      let date = item?.date?.split("T")[0];
                      return (
                        <tr key={key}>
                          <td className="text-body fw-bold">{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                          <td>{item?.enquiry_no || "-"}</td>
                          <td>{item?.name || "-"}</td>
                          <td>{item?.email || "-"}</td>
                          <td>{item?.contact_number || "-"}</td>
                          <td>{(date && date) || "-"}</td>
                          <td style={{ whiteSpace: "normal" }}>
                            {item?.address || "-"}
                          </td>
                          <td>
                            <Button
                              style={{ width: 100 }}
                              onClick={() => handleCotation(item)}
                              className={
                                item.quotation_send === true
                                  ? "btn btn-primary"
                                  : "btn btn-danger"
                              }
                            >
                              {(item.quotation_send === true && "Quoted") ||
                                "Not Quoted"}
                            </Button>
                          </td>
                          {/* {/ <td>{item?.retailer_address || "-"}</td> /} */}
                          <td>
                            <MdVisibility
                              className="pointer"
                              onClick={() =>
                                history.push("/enquiry-view?id=" + item._id)
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <div className="text-center">
                {(loader && <Spinner animation="grow" size="sm" />) || ""}
              </div>
              {enquirylist?.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                  {/* {/ <Spinner animation="grow" size="sm" /> /} */}
                </div>
              )}

              {enquirylist &&
                enquirylist.length > 0 &&
              pagination.total_record > pagination.limit && (
                <ReactPaginate
                  previousLabel={
                    <img
                      src="assets/images/prev.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  forcePage={currentPage - 1}
                  nextLabel={
                    <img
                      src="assets/images/next.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.total_record / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(e) => onPageChangeEvent(e)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryList;
